export default "__VITE_ASSET__c5b61294__"